import { useStore } from 'effector-react'
import * as React from 'react'
import { $giftOrder, getGiftOrder, giftOrderMounted } from './model'

export const useGiftOrderDetails = () => {
  const giftOrder = useStore($giftOrder)
  const loading = useStore(getGiftOrder.pending)

  React.useEffect(() => {
    giftOrderMounted()
  }, [])

  return { giftOrder, loading }
}
